/**
 * Undo/Redo System Exports
 *
 * Phase 4: Optimistic mutations with inverse operations.
 */

// Provider and hook
export { UndoProvider, useUndo } from './UndoContext'

// Mutation wrapper
export { useUndoableMutation, type UseUndoableMutationOptions, type UndoableMutationResult } from './UseUndoableMutation'

// Execution functions
export { executeInverse } from './ExecuteInverse'
export { executeRedo } from './ExecuteRedo'

// Types
export {
	MAX_UNDO_LEVELS,
	generateOperationId,
	generateTransactionId,
	type BlockMutationType,
	type UndoableOperation,
	type UndoStackState,
	type UndoActions,
	type UndoContextValue,
	// Inverse data types
	type InverseOperationData,
	type CreateBlockInverseData,
	type UpdateBlockInverseData,
	type DeleteBlockInverseData,
	type CreateReferenceInverseData,
	type DeleteReferenceInverseData,
	type MoveBlockInverseData,
	type ReorderBlocksInverseData,
	// Redo data types
	type RedoOperationData,
	type CreateBlockRedoData,
	type UpdateBlockRedoData,
	type DeleteBlockRedoData,
	type CreateReferenceRedoData,
	type DeleteReferenceRedoData,
	type MoveBlockRedoData,
	type ReorderBlocksRedoData,
} from './Types'
